import { Title, type TitleProps } from '@mantine/core'
import { clsx } from 'clsx'

import classes from './styles.module.css'

export function PageTitle({ children, className }: TitleProps) {
  const titleClasses = clsx(classes.pageTitle, className)

  return (
    <Title className={titleClasses} order={3}>
      {children}
    </Title>
  )
}

PageTitle.displayName = 'PageTitle'
